import React from 'react'
import Moment from 'react-moment'

export const DateFormatter = {
  getLastDateInMonth,
  formatMonth,
  getMonthName,
  getFinalInvoicePeriodEndDate
}

function getLastDateInMonth (date) {
  const dateObj = new Date(date)
  return formatMonth(new Date(dateObj.getFullYear(), dateObj.getMonth() + 1, 0, 23, 59, 59))
}

function formatMonth (date) {
  return (
    <Moment format="YYYY-MM-DD">
      {date}
    </Moment>
  )
}

function getMonthName (date, language = 'sv-se') {
  const dateObj = new Date(date)
  return dateObj.toLocaleString(language, { month: 'long' })
}

function getFinalInvoicePeriodEndDate (date) {
  const dateObj = new Date(date)
  return formatMonth(dateObj.setDate(dateObj.getDate() - 1))
}
